import type { Locale } from "@/lib/i18n/config";

const CARD_LANGUAGE_FLAG_CODES: Record<string, string> = {
  en: "US",
  ja: "JP",
  fr: "FR",
  de: "DE",
  es: "ES",
  it: "IT",
  ko: "KR",
  pt: "PT",
  zh: "CN",
};

const LOCALE_FLAG_CODES: Record<Locale, string> = {
  en: "US",
  fr: "FR",
  es: "ES",
  it: "IT",
  de: "DE",
  pl: "PL",
  zh: "CN",
  ja: "JP",
  ko: "KR",
};

export function countryCodeToEmoji(countryCode: string): string {
  const normalized = countryCode.trim().toUpperCase();
  if (normalized.length !== 2) return "";
  const codePoints = normalized
    .split("")
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}

export function getCardLanguageFlag(slug?: string | null): string {
  if (!slug) return "";
  const code = CARD_LANGUAGE_FLAG_CODES[slug.trim().toLowerCase()];
  return code ? countryCodeToEmoji(code) : "";
}

export function getLocaleFlag(locale: Locale): string {
  return countryCodeToEmoji(LOCALE_FLAG_CODES[locale]);
}
